import { AppLayout } from "../shared";
import EditAdvertisement from "../Advertisement/edit_advertisement";

const Edit_Advertisement_layout = ({ props, setIsLoaded }) => {
  return (
    <AppLayout props={props}>
      <EditAdvertisement props={props} setIsLoaded={setIsLoaded} />
    </AppLayout>
  );
};

export default Edit_Advertisement_layout;
